import PropTypes from 'prop-types';
import React from 'react';

import { Header, ProgressBar } from '@coursera/components';

export const PluginContainer = ({
  children,
  pluginTitle,
  pluginSubtitle,
  progress,
  showProgress,
}) => {
  return (
    <>
      <Header>
        <h1>{pluginTitle}</h1>
        <p>{pluginSubtitle}</p>
      </Header>
      {showProgress ? <ProgressBar progress={progress} /> : null}
      <section>{children}</section>
    </>
  );
};

PluginContainer.propTypes = {
  children: PropTypes.node,
  pluginTitle: PropTypes.string,
  pluginSubtitle: PropTypes.string,
  progress: PropTypes.number,
  showProgress: PropTypes.bool,
};

PluginContainer.defaultProps = {
  progress: 0,
  showProgress: false,
};
